(() => {
  const label = document.currentScript?.dataset.addBundleLabel;
  if (!label) return;

  const observed = new WeakSet();
  const originalLabel = /^(add bundle to cart|add to cart)$/i;

  function observeBundles(scope) {
    scope.querySelectorAll('.cz-product-layout .cz-product-bundle').forEach((bundle) => {
      if (observed.has(bundle)) return;
      observed.add(bundle);

      const updateLabel = () => {
        bundle.querySelectorAll('#rebuy-widget-20887 .rebuy-bundle__actions-buttons > .rebuy-button').forEach((button) => {
          if (originalLabel.test(button.textContent.trim())) {
            button.textContent = label;
          }
          if (originalLabel.test(button.getAttribute('aria-label') || '')) {
            button.setAttribute('aria-label', label);
          }
        });
      };

      new MutationObserver(updateLabel).observe(bundle, {
        childList: true,
        characterData: true,
        subtree: true
      });
      updateLabel();
    });
  }

  observeBundles(document);
  document.addEventListener('shopify:section:load', () => observeBundles(document));
})();
